import React from "react";
const IconStar25Filled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99946 2.5L12.4728 7.43757L18 8.22928L14.0008 12.0729L14.944 17.5L9.99946 14.9376L5.05707 17.5L6.00027 12.0729L2 8.22928L7.52827 7.43757L9.99946 2.5Z"
      fill="currentColor"
    />
    <path d="M6.00027 12.0734L5.05707 17.5004L7 16.4931V7.51367L2 8.22973L6.00027 12.0734Z" fill="currentColor" />
  </svg>
);
export default IconStar25Filled;
